import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:8000";

export const tenderApi = {
  // Dashboard
  getStats:    ()      => axios.get(`${API_URL}/stats`).then(res => res.data),

  // Tenders
  listTenders: (params) => axios.get(`${API_URL}/tenders`, { params }).then(res => res.data),
  getTender:   (id)    => axios.get(`${API_URL}/tenders/${id}`, { suppressErrorAlert: true }).then(res => res.data),

  // Portals
  listPortals: ()      => axios.get(`${API_URL}/portals`).then(res => res.data),

  // Filter values the stored tenders actually have, with counts. Scoped to one
  // portal when given, so the Type dropdown only offers what that portal publishes.
  listFacets:  (params) => axios.get(`${API_URL}/tenders/facets`, { params }).then(res => res.data)
};

export default tenderApi;
